import {avatarTheme} from '../components/Avatar';
import {buttonTheme} from '../components/Button/theme';
import {displayTheme} from '../components/Display/theme';
import {dividerTheme} from '../components/Divider';
import {headingTheme} from '../components/Heading/theme';
import {inputTheme} from '../components/Input/theme/theme';
import {labelTheme} from '../components/Label/theme';
import {skeletonTheme} from '../components/Skeleton/theme';
import {textTheme} from '../components/Text/theme';

/**
 * Since those are widely used components, we add them to the global theme context (vs injecting them into the components directly)
 */
export const components = {
  Avatar: avatarTheme,
  Button: buttonTheme,
  Divider: dividerTheme,
  Heading: headingTheme,
  Skeleton: skeletonTheme,
  Label: labelTheme,
  Text: textTheme,
  Input: inputTheme,
  Display: displayTheme,
};
